export default [{
    name: 'На улице',
    key: 'outdoors',
}, {
    name: 'В доме',
    key: 'indoors',
}];
